<template>
  <div>
    <div>
      <h3 style="margin-bottom: 20px">修改手机号</h3>
      <el-form style="width: 50%" ref="form" :model="form" :rules="rules" label-position="left">
        <el-form-item prop="phoneNumber" id="personalItem" v-if="!editVisible">
          <div class="defaultClass">
            <div>
              <img slot="prefix" src="../../assets/img/dh.png" class="login-input__icon" />
            </div>
            <div class="phoneNumber">{{userInfo.phoneNumber}}</div>
          </div>
        </el-form-item>
        <div v-if="editVisible">
          <el-form-item prop="oldPhone">
            <el-input v-model="form.oldPhone" disabled placeholder="请输入手机号">
              <img slot="prefix" src="../../assets/img/dh.png" class="login-input__icon" />
            </el-input>
          </el-form-item>
          <el-form-item prop="newPhone">
            <el-input v-model="form.newPhone" placeholder="请输入新手机号">
              <img slot="prefix" src="../../assets/img/dh.png" class="login-input__icon" />
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div class="defaultClass">
              <div style="width: 80%">
                <el-input v-model="form.code" placeholder="请输入短信验证码" >
                  <img slot="prefix" src="../../assets/img/yzm.png" class="login-input__icon" />
                </el-input>
              </div>
              <div style="width:20%">
                <el-button  v-show="show" @click="sendCode">获取验证码</el-button>
                <el-button
                  v-show="!show"
                  :disabled="isdisabled"
                >{{count}}S</el-button>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div style="width: 50%;text-align: center;">
        <el-button type="primary" style="width: 150px" v-if="!editVisible" @click="editData">修改手机号</el-button>
        <el-button style="width: 120px" v-if="editVisible" @click="cancel()">取消</el-button>
        <el-button type="primary" v-if="editVisible" style="width: 120px" @click="saveData()">确认</el-button>
      </div>
    </div>
    <div style="margin-top: 50px;">
      <h3 style="margin-bottom: 20px">添加/修改登录密码</h3>
      <el-form style="width: 50%" ref="pwdform" :model="form" :rules="pwdrules" label-position="left">
        <div>
          <el-form-item prop="password">
            <el-input type="password" v-model="form.password" placeholder="请输入您的新密码"></el-input>
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input type="password" v-model="form.confirmPassword" placeholder="请再次输入您的新密码"></el-input>
          </el-form-item>
          <el-form-item prop="pwdcode">
            <div class="defaultClass">
              <div style="width: 80%">
                <el-input v-model="form.pwdcode" placeholder="请输入短信验证码" >
                  <img slot="prefix" src="../../assets/img/yzm.png" class="login-input__icon" />
                </el-input>
              </div>
              <div style="width:20%">
                <el-button  v-show="pwdshow" @click="sendpwdMsg">获取验证码</el-button>
                <el-button
                  v-show="!pwdshow"
                  :disabled="pwdisdisabled"
                >{{pwdcount}}S</el-button>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div style="width: 50%;text-align: center;">
        <el-button type="primary" style="width: 120px" @click="setPassword()">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { sendCode, updatePhone , setPwdOrEdit , sendPwdCode } from "@/api/request";
import { mapGetters } from 'vuex'
import { isMobile, validEmail } from "@/plugins/validate";
import { getClient } from "@/plugins/auth";
export default {
  props: {
    info: {
      type: [Object, Array],
      default: () => {}
    }
  },
  data() {
    var validateMobile = (rule, value, callback) => {
      if (value && !isMobile(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    return {
      show: true,
      pwdshow: true,
      count: "",
      pwdcount: '',
      timer: null,
      pwdtimer: null,
      isdisabled: false,
      pwdisdisabled: false,
      userInfo: JSON.parse(getClient()),
      editVisible: false,
      form: {
        oldPhone: "",
        newPhone: "",
        code: "",
        pwdcode: ""
      },
      rules: {
        newPhone: [
          { required: true, trigger: "blur", message: "请输入新手机号" },
          { validator: validateMobile, trigger: "blur" }
        ],
        code: [{ required: true, trigger: "blur", message: "请输入验证码" }]
      },
      pwdrules: {
        password: [
          { required: true, trigger: "blur", message: "请输入密码" }
        ],
        confirmPassword: [{ required: true, trigger: "blur", message: "请输入密码" }],
        pwdcode: [{ required: true, trigger: "blur", message: "请输入验证码" }]
      }
    };
  },
  // computed: {
  //   ...mapGetters(['userInfo']),
  // },
  methods: {
    editData() {
      this.editVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
        this.form.oldPhone = this.$store.getters.userInfo.phoneNumber;
      });
    },
    setPassword(){
      // if(this.form.password){
        
      // }
      this.$refs.form.validate(valid => {
        if (valid) {
          // if(this.)
          const regex = /^[A-Za-z0-9]{6,15}$/;
          let flag = regex.test(this.form.password)
          if(flag){
            if(this.form.password === this.form.confirmPassword){
              let obj = {
                clientId: this.userInfo.clientId,
                password: this.form.password,
                code: this.form.pwdcode
              }
              setPwdOrEdit(obj).then(res => {
                // this.editVisible = false;
                this.$refs["pwdform"].resetFields();
                this.$message.success("修改成功");
                this.$store
                  .dispatch("GetInfo")
                  .then(() => {})
                  .catch(err => {});
              });
            }else{
              this.$message.warning('两次输入的密码不一致');
            }
          }else{
            this.$message.warning('密码需为6-15位，包含数字+字母，不含特殊符号');
          }
        }
      });
    },
    saveData() {
      this.$refs.form.validate(valid => {
        if (valid) {
          updatePhone(this.form).then(res => {
            this.editVisible = false;
            this.$message.success("修改成功");
            this.$store
              .dispatch("GetInfo")
              .then(() => {})
              .catch(err => {});
          });
        }
      });
    },
    //获取验证码
    sendpwdMsg(){
      sendPwdCode({ phoneNumber: this.userInfo.phoneNumber }).then(res => {
        if (res.code == 200) {
          const TIME_COUNT = 60;
          if (!this.pwdtimer) {
            this.pwdcount = TIME_COUNT;
            this.pwdshow = false;
            this.pwdtimer = setInterval(() => {
              if (this.pwdcount > 0 && this.pwdcount <= TIME_COUNT) {
                this.pwdcount--;
              } else {
                this.pwdisdisabled = false;
                this.pwdshow = true;
                clearInterval(this.pwdtimer);
                this.pwdtimer = null;
              }
            }, 1000);
          }
        }
      });
    },
    //获取验证码
    sendCode() {
      if (this.form.newPhone == "") {
        return this.$message.error("请输入手机号");
      }
      if (!isMobile(this.form.newPhone)) {
        return false;
      }
      sendCode({ phoneNumber: this.form.newPhone }).then(res => {
        if (res.code == 200) {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.isdisabled = false;
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    cancel() {
      this.form.newPhone = ''
      this.form.code = ''
      this.editVisible = false;
    }
  }
};
</script>
<style scoped>
.defaultClass {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
}
.phoneNumber {
  margin-left: 10px;
}
</style>